import UltMeta, { Meta } from "@/meta/UltMeta/index";

class InvoiceType extends UltMeta {
    DOWNSTREAM_UPSTREAM = new Meta(1, "直采 - 供应商");
    DOWNSTREAM_MIDSTREAM = new Meta(2, "联合采购 - 联合购销商");
    MIDSTREAM_UPSTREAM = new Meta(3, "联合采购 - 供应商");
}
export const INVOICE_TYPE = new InvoiceType();
